export default "__VITE_ASSET__BfyR5FkL__"